import React, { FC } from "react";
import { faVimeoV } from "@fortawesome/free-brands-svg-icons/faVimeoV";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Vimeo: FC<JSX.IntrinsicAttributes> = (props) => {
  return <FontAwesomeIcon icon={faVimeoV} {...props} />;
};
